// @ts-nocheck
const themeTOGGLER = Vue.component('theme-toggler', {
  template: "#theme-toggler",

  data() {
    return {
      body: null,
      isDarkMode: false
    }
  },

  methods: {
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode
    }
  },

  watch: {
    isDarkMode(v) {
      if(this.body) {
        if(v) {
          this.body.classList.add('dark-theme')
        } else {
          this.body.classList.remove('dark-theme')
        }
      }
      localStorage.setItem('dark-theme', v ? '1' : '0')
      localStorage.setItem('system-preference', '0')

      window.dispatchEvent(new CustomEvent('dark-mode-changed'));
    }
  },

  beforeMount() {
    this.body = document.querySelector('body')
    const v = localStorage.getItem('dark-theme')
    this.isDarkMode = (v && v === '1') ? true : false

    if(localStorage.getItem('system-preference') == '1') {
      if(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.isDarkMode = true
        this.body.classList.add('dark-theme')
        localStorage.setItem('system-preference', '1')
      } else {
        this.isDarkMode = false
        this.body.classList.remove('dark-theme')
        localStorage.setItem('system-preference', '1')
      }
    }
  }
})
